module.exports = __webpack_public_path__ + "static/media/logo512-trimmy.c58f8204.png";